var React = require('react');

var DropDown = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        options: React.PropTypes.array.isRequired,
        value: React.PropTypes.oneOfType([
            React.PropTypes.number,
            React.PropTypes.string
        ]),
        valueField: React.PropTypes.string,
        labelField: React.PropTypes.string,
        errorMessage: React.PropTypes.string,
        visible: React.PropTypes.bool,
        onChange: React.PropTypes.func
    },
    getDefaultProps: function() {
        return {
            value: '',
            valueField: 'value',
            labelField: 'label',
            errorMessage: '',
            onChange: null,
            visible: false
        };
    },
    getInitialState: function() {
        var selected = this.getSelectedFromProps(this.props);
        return {
            selected: selected,
            valid: true
        }
    },
    componentWillReceiveProps: function(nextProps) {
        var selected = this.getSelectedFromProps(nextProps);
        this.setState({
            selected: selected
        });
    },
    getSelectedFromProps: function(props) {
        var selected;
        if (props.value === null && props.options.length !== 0) {
            selected = props.options[0][props.valueField];
        } else {
            selected = props.value;
        }
        return selected;
    },
    render: function() {
        var self = this;
        var options = self.props.options.map(function(option) {
            return (
                <option key={option[self.props.valueField]} value={option[self.props.valueField]}>
                    {option[self.props.labelField]}
                </option>
            )
        });

        var labelCssClass = ['select', 'input'];
        if (!this.state.valid) {
            labelCssClass.push('error-view');
        }

        var selectCssClass = 'form-control';
        if (!this.props.visible) {
            selectCssClass += ' disabled';
        }

        return (
            <label className={labelCssClass.join(' ')}>
                <select id={this.props.id}
                        className={selectCssClass}
                        value={this.state.selected}
                        onChange={this.handleChange}
                        disabled={!this.props.visible}>
                    {options}
                </select>
                <i></i>
            </label>
        )
    },
    handleChange: function(e) {
        if (this.props.onChange) {
            var change = {
                oldValue: this.state.selected,
                newValue: e.target.value,
                id: e.target.id,
                errorMessage: this.props.errorMessage
            };
            this.props.onChange(change);
        }
        this.setState({selected: e.target.value});
    },
    validate: function (text) {
        var textToValidate = text != null ? text : this.state.selected;
        var isValid = textToValidate != '';
        this.setState({
            valid: isValid
        });
        return isValid;
    }
});

module.exports = DropDown;



// WEBPACK FOOTER //
// ./app/components/DropDown.js